import React from 'react';
import TimerPanel from '../components/timer/TimerPanel';
import TodoPanel from '../components/todo/TodoPanel';
import './home.css';

export default function HomePage() {
  return (
    <div className="home">
      <header className="home-header">
        <h1 className="brand">Analyte Focus</h1>
        <p className="subtitle">Plan your tasks and focus in short sprints.</p>
      </header>
      <main className="home-main">
        <section className="pane timer-pane" aria-label="Pomodoro Timer">
          <TimerPanel />
        </section>
        <section className="pane todo-pane" aria-label="Todo List">
          <TodoPanel />
        </section>
      </main>
    </div>
  );
}
